"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityExistsResponse = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class EntityExistsResponse extends base_models_1.Serializable {
}
exports.EntityExistsResponse = EntityExistsResponse;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        description: 'list of ids of found entities. Empty list if nothing found. Typically has only one result',
        example: ['123', '456'],
    }),
    tslib_1.__metadata("design:type", Array)
], EntityExistsResponse.prototype, "results", void 0);
